import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TableCellComponent } from '@vsolv/vectors/table';
import { Observable } from 'rxjs';

export interface CheckboxCellState {
  checked: boolean;
  disabled?: boolean;
  /** Shown when disabled, to explain why the row cannot be picked. */
  tooltip?: string;
}

export interface CheckboxCellProps {
  /** vs-table builds cell props once per row, so everything live has to arrive as a stream. */
  state$: Observable<CheckboxCellState>;

  ariaLabel?: string;

  toggled(): void;
}

// Default CD like the built-in columns — TableCellComponent resolves `data` on a microtask, so an
// OnPush cell renders empty.
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  template: `
    <ng-container *ngIf="data as props">
      <div *ngIf="props.state$ | async as state" [vsTooltip]="state.tooltip" tooltipStyle="light">
        <input
          type="checkbox"
          vsInput
          class="theme-primary"
          [checked]="state.checked"
          [disabled]="!!state.disabled"
          [attr.aria-label]="props.ariaLabel ?? 'Select row'"
          (change)="props.toggled()"
          (click)="$event.stopPropagation()"
        />
      </div>
    </ng-container>
  `,
})
export class CheckboxCellComponent extends TableCellComponent<CheckboxCellProps> {}
